var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMutedMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.858 331.374C275.03 334.024 265.677 335.448 256 335.448C202.469 335.448 158.896 291.875 158.896 238.345V176.552H123.586V238.345C123.586 305.364 173.674 360.766 238.345 369.435V441.379H176.551V476.69H335.448V441.379H273.655V369.435C284.182 368.023 294.322 365.374 303.924 361.638L283.858 331.374ZM353.815 327.407C375.294 303.901 388.414 272.644 388.414 238.345V176.552H353.103V238.345C353.103 260.258 345.801 280.503 333.504 296.773L353.815 327.407Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.203 196.155V238.345C194.203 254.734 200.713 270.451 212.302 282.039C223.89 293.628 239.608 300.138 255.996 300.138C258.311 300.138 260.613 300.008 262.891 299.752L194.203 196.155ZM312.032 264.39C315.789 256.307 317.789 247.429 317.789 238.345V97.1037C317.789 88.9889 316.191 80.9535 313.086 73.4565C309.98 65.9594 305.429 59.1474 299.691 53.4093C293.953 47.6713 287.141 43.1197 279.643 40.0143C272.146 36.9089 264.111 35.3105 255.996 35.3105C247.881 35.3105 239.846 36.9089 232.349 40.0143C224.852 43.1197 218.04 47.6713 212.302 53.4093C206.564 59.1474 202.012 65.9594 198.907 73.4565C197.002 78.0542 195.665 82.8543 194.915 87.7511L312.032 264.39Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128.016,
    y: 27.9702,
    width: 537.017,
    height: 15.0546,
    transform: "rotate(56.4543 128.016 27.9702)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedMicIcon);
export default __webpack_public_path__ + "static/media/muted_mic_icon.93f72a1f69fa5bd9ba78fd58bbbba321.svg";
export { ForwardRef as ReactComponent };